/*
	<input type="text" ng-model="mymodel.ssn" dp-valid-idnumber />
*/

'use strict';

angular.module('theme').directive('validNbSsn', function ($parse, SsnNbService) {
	return {
		require: 'ngModel',
		link: function(scope, element, attr, ngModelCtrl) {

			var validNumber = function (value) {
				// Only validate if there is anything to validate
				if (ngModelCtrl.$isEmpty(value)) {
					ngModelCtrl.$setValidity('ssn-nb', true);
					return undefined;
				}

				var service = SsnNbService(value);
				if (service.valid && service.ssn) {
					ngModelCtrl.$setValidity('ssn-nb', true);
					ngModelCtrl.$viewValue = service.formatted;
					ngModelCtrl.$render();
					return service.formatted;
				} else {
					ngModelCtrl.$setValidity('ssn-nb', false);
					return undefined;
				}
			};

			ngModelCtrl.$parsers.push(validNumber);
			ngModelCtrl.$formatters.push(validNumber);
		}
	};
});
